import { useEffect } from 'react';
import {ThemeConfig} from "./dataTypes/ThemeConfig";

const useUpdateDocumentElements = (themeConfig: ThemeConfig | null) => {
    useEffect(() => {
        if (!themeConfig) return;

        const { color, favicon_img, logo_img, title } = themeConfig;

        document.title = title || "Default Title";

        const faviconElement = document.getElementById('favicon') as HTMLLinkElement;
        if (faviconElement && favicon_img) {
            faviconElement.href = favicon_img;
        }

        // Additional logic to update other document elements
    }, [themeConfig]);
};
export default useUpdateDocumentElements;
